<template>
  <section class="create-specification">
    <header>
      <h1>New Specification</h1>
    </header>
    <p-edit-specification-form :is-request-pending="isCreateRequestPending" :is-request-failed="isCreateRequestFailed" @submit="submit" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import CreateForm from './_CreateOrEdit';

export default {
  components: {
    'p-edit-specification-form': CreateForm
  },
  computed: {
    ...mapState({
      isCreateRequestPending: s => s.specifications.isCreateRequestPending,
      isCreateRequestFailed: s => s.specifications.isCreateRequestFailed
    })
  },
  methods: {
    async submit(props) {
      const { id } = await this.$store.dispatch('specifications/create', props);
      this.$router.push({ path: `/specifications/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.create-specification {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
